import { Controller } from "react-hook-form";
import { MuiPhone } from "./MuiPhone";
import { getHelperText } from "../../yupLocalization";
import { useTranslation } from "react-i18next";

/**
 * Reusable FormPhone - Combines Controller + MuiPhone pattern
 * Reduces code duplication in forms significantly
 */
function FormPhone({ 
    name, 
    control, 
    label, 
    errors, 
    disabled,
    countryIso,
    variant = "standard",
    fullWidth = true,
    ...phoneProps 
}) {
    const { t } = useTranslation();
    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => (
                <MuiPhone
                    {...field}
                    label={label}
                    variant={variant}
                    
                    disabled={disabled}
                    fullWidth={fullWidth}
                    countryIso={countryIso}
                    error={!!errors[name]}
                    helperText={getHelperText(t, errors, name)}
                    {...phoneProps}
                />
            )}
        />
    );
}

export default FormPhone; 